export default __webpack_public_path__ + "static/media/radish-3.26895fae.svg";